(function () {
  var VISIBLE_CLASS = "smQuickBuy__stepTwo--visible";
  var OOS_CLASS = "smQuickBuy__stepTwoSizeButton--oos";
  var adding = false;

  function normalize(value) {
    return value == null ? "" : String(value).toLowerCase();
  }

  function getOptions(stepTwo) {
    return stepTwo ? Array.from(stepTwo.querySelectorAll("option")) : [];
  }

  function parseTitle(option) {
    return (option.getAttribute("data-title") || "").split("|");
  }

  function getSelectedColor(productCard) {
    if (!productCard) return undefined;

    // Split cards fix their color on the element itself.
    if (productCard.dataset && productCard.dataset.color) {
      return productCard.dataset.color;
    }

    var checked = productCard.querySelector(
      ".product-card__info fieldset :checked"
    );
    return checked ? checked.getAttribute("value") : undefined;
  }

  function openStepTwo(stepTwo) {
    closeAllStepTwo();
    if (stepTwo) stepTwo.classList.add(VISIBLE_CLASS);
  }

  function closeAllStepTwo() {
    document.querySelectorAll("." + VISIBLE_CLASS).forEach(function (element) {
      element.classList.remove(VISIBLE_CLASS);
    });
  }

  async function smAddToCart(variantId, quantity) {
    var body = new FormData();
    body.set("id", variantId);
    body.set("quantity", quantity || 1);

    try {
      var response = await fetch(Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: body,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      var responseJson = await response.json();

      if (!response.ok) {
        console.error("Add to cart failed:", responseJson.description);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        return;
      }

      var cart = await (await fetch(Shopify.routes.root + "cart.js")).json();

      document.documentElement.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cart,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: { baseEvent: "variant:add", cart: cart },
        })
      );
    } catch (error) {
      console.error("Add to cart failed:", error);
    } finally {
      adding = false;
    }
  }

  function onStepOneClick(button, event) {
    event.stopPropagation();

    var parent = button.parentElement;
    var stepTwo = parent && parent.querySelector(".smQuickBuy__stepTwo");
    var options = getOptions(stepTwo);

    var sizeValues = [];
    options.forEach(function (option) {
      var titleParts = parseTitle(option);
      var size = titleParts.length > 1 ? titleParts[1] : titleParts[0];
      if (size !== undefined && !sizeValues.includes(size)) {
        sizeValues.push(size);
      }
    });

    if (sizeValues.length === 1) {
      if (adding) return;

      var selectedColor = getSelectedColor(button.closest(".product-card"));
      var selectedID = null;
      var selectedAvailable = "false";

      options.forEach(function (option) {
        var titleParts = parseTitle(option);
        var hasColor = titleParts.length > 1;
        var optionColor = hasColor ? titleParts[0] : null;
        var optionSize = hasColor ? titleParts[1] : titleParts[0];

        var isSizeMatch = normalize(optionSize) === normalize(sizeValues[0]);
        var isColorMatch =
          !optionColor || !selectedColor || selectedColor === optionColor;

        if (isSizeMatch && isColorMatch) {
          selectedID = option.getAttribute("value");
          selectedAvailable = option.getAttribute("data-available");
        }
      });

      if (selectedAvailable === "true" && selectedID) {
        adding = true;
        smAddToCart(selectedID);
      }

      return;
    }

    if (stepTwo && stepTwo.classList.contains(VISIBLE_CLASS)) {
      closeAllStepTwo();
    } else {
      openStepTwo(stepTwo);
    }
  }

  function onSizeButtonClick(sizeButton) {
    if (adding) return;
    adding = true;

    var selectedSize = sizeButton.getAttribute("data-size");
    var selectedColor = getSelectedColor(sizeButton.closest(".product-card"));
    var selectedID = 0;
    var selectedAvailable = "false";

    getOptions(sizeButton.closest(".smQuickBuy__stepTwo")).forEach(function (
      option
    ) {
      var optionArray = parseTitle(option);
      var isSizeMatch = normalize(selectedSize) === normalize(optionArray[1]);
      var isColorMatch =
        !selectedColor || normalize(selectedColor) === normalize(optionArray[0]);

      if (isSizeMatch && isColorMatch) {
        selectedID = option.getAttribute("value");
        selectedAvailable = option.getAttribute("data-available");
      }
    });

    if (selectedAvailable === "true") {
      smAddToCart(selectedID);
    } else {
      adding = false;
    }
  }

  function setSizeOOS(productCard, specColor) {
    if (!productCard) return;

    productCard
      .querySelectorAll(".smQuickBuy__stepTwoSizeButton")
      .forEach(function (button) {
        button.classList.remove(OOS_CLASS);
      });

    var selectedColor = specColor || getSelectedColor(productCard);

    // The size buttons are rendered from the union of every size the product has,
    // so a color with fewer variants must also mark the sizes it never carries.
    // Collect the sizes that ARE purchasable for this color and mark the rest OOS.
    var availableSizes = [];

    productCard
      .querySelectorAll(".smQuickBuy__stepTwo option")
      .forEach(function (option) {
        var optionArray = parseTitle(option);
        var hasColor = optionArray.length > 1;
        var optionColor = hasColor ? optionArray[0] : null;
        var optionSize = hasColor ? optionArray[1] : optionArray[0];

        var isColorMatch =
          !optionColor ||
          !selectedColor ||
          normalize(optionColor) === normalize(selectedColor);

        if (isColorMatch && option.getAttribute("data-available") === "true") {
          availableSizes.push(normalize(optionSize));
        }
      });

    productCard
      .querySelectorAll(".smQuickBuy__stepTwoSizeButton")
      .forEach(function (button) {
        var size = normalize(button.getAttribute("data-size"));
        if (!availableSizes.includes(size)) {
          button.classList.add(OOS_CLASS);
        }
      });
  }

  function initCards(root) {
    (root || document)
      .querySelectorAll(".product-card")
      .forEach(function (card) {
        setSizeOOS(card);
      });
  }

  document.addEventListener("click", function (event) {
    var stepOneButton = event.target.closest(".smQuickBuy__stepOneButton");
    if (stepOneButton) {
      onStepOneClick(stepOneButton, event);
      return;
    }

    var sizeButton = event.target.closest(".smQuickBuy__stepTwoSizeButton");
    if (sizeButton) {
      onSizeButtonClick(sizeButton);
      return;
    }

    var swatch = event.target.closest(".product-card__info .color-swatch");
    if (swatch) {
      setSizeOOS(swatch.closest(".product-card"), swatch.getAttribute("title"));
    }

    if (!event.target.closest(".smQuickBuy__stepTwo")) {
      closeAllStepTwo();
    }
  });

  // Cards injected by filtering or infinite scroll need their OOS state applied too.
  function observeNewCards() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(".product-card")) {
            setSizeOOS(node);
          } else {
            initCards(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initCards();
    observeNewCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = document.getElementById(
      "shopify-section-" + event.detail.sectionId
    );
    initCards(section);
  });
})();
